<template>
  <div class="landing-content">
    <div class="landing-content-left">
      <h1 class="landing-content-left-header">
        Trading energy <br />made easy
      </h1>
      <p class="landing-content-left-text">
        EFLEX allows you to buy and sell energy easier than ever before.
      </p>
      <a href="/register" class="landing-button">Get Started</a>
    </div>
    <div class="landing-content-right">
      <img src="../../img/hero2.png" alt="Eflex on laptop" />
      <!-- <lottie :options="defaultOptions" :height="500" :width="720" /> -->
    </div>
  </div>
</template>

<script>
import * as animationData from "../../assets/energyOpen.json";
export default {
  data() {
    return {
      defaultOptions: { animationData: animationData.default },
    };
  },
};
</script>

<style lang="scss">
@import "../../sass/main.scss";

.landing-content {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  min-height: calc(100vh - 80px);
  width: 100%;
  max-width: 1200px;
}

.landing-content-left {
  width: 40%;
}

.landing-content-left-header {
  font-size: 48px;
  font-weight: 700;
}

.landing-content-left-text {
  font-size: 24px;
  margin-top: 20px;
}

.landing-button {
  color: #fff !important;
  background: $green2;
  padding: 10px 30px;
  border-radius: 20px;
  margin-top: 30px;
  font-weight: 700;
  letter-spacing: 1.2px;
  display: inline-block;
}

.landing-button:hover {
  color: #fff;
  text-decoration: none;
  background: hsl(144, 58%, 40%);
}

.landing-content-right {
  width: 60%;
  display: flex;
  justify-content: center;
  align-content: center;
}

.landing-content-right img {
  width: 90%;
}
</style>